import React, { useCallback, useState, useRef } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { Link } from 'react-router-dom';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import Pagination from 'components/pagination/Pagination';
import { useForm } from 'react-hook-form';
import { currency } from 'resources/utilities';
import { useGlobalState } from 'resources/GlobalStateContext';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';

const AddEdit = ({ history, match, saludo, subtitulo }) => {
    const { setGlobalTitulo } = useGlobalState();
    const [facturado, setFacturado] = useState(false);
    const { handleSubmit } = useForm();
    const { id } = match.params
    const { documento } = match.params;
    let [documentoS,] = useState(documento);
    let [TipoDocto, setTipoDocto] = useState('C');
    let [Docto, setDocto] = useState('C');
    const isAddMode = !id;
    const [isOpenModal, openModal, closeModal] = useModal(false);
    const [modalValor, setModalValor] = useState(false);
    let [cliente, setCliente] = useState([]);
    let [clientes, setClientes] = useState([]);
    let [direcciones, setDirecciones] = useState([]);
    let [direccionesList, setDireccionesList] = useState([]);
    let [venta, setVenta] = useState({
        id: 0,
        empresa_Id: getDataSession('empresa'),
        sucursal_Id: getDataSession('sucursal'),
        cliente_Id: 0,
        direccion_Id: 0,
        no_Orden: '',
        folio: '',
        moneda: 'MXN',
        descuento_Importe: 0,
        estatus: 'P',
        importe_Total_Impuestos: 0,
        metodo_Pago: '',
        clave_Envio: '',
        forma_De_Pago: '',
        tipo_Documento: TipoDocto,
        descripcion: '',
        almacen_Id: 0
    });
    let [ventaDetalles, setVentaDetalles] = useState([]);
    let [articulos, setArticulos] = useState([]);
    let [,] = useState('');
    let [sucursal_id,] = useState(getDataSession('sucursal'));
    let [, setSucursales] = useState([]);
    let [, setSeries] = useState([]);
    const totalxPagina = 10;
    const busqueda = useFormInput('');
    let [error, setError] = useState(['']);
    let [erroresCliente, setErroresCliente] = useState({});
    let [erroresDirecciones, setErroresDirecciones] = useState({});
    let [erroresV, setErroresV] = useState({});
    const [satFormaPago, setSatFormaPago] = useState(['']);
    const [satPais, setSatPais] = useState(['']);
    const [almacenes, setAlmacenes] = useState([]);
    const [conceptoPago, setConceptoPago] = useState([]);
    const [condicionPago, setCondicionPago] = useState([]);
    const [conceptos_cobros_id, setConceptos_cobros_id] = useState(0);
    const [condicion_pago_id, setCondicion_pago_id] = useState(0);
    const ventaAlmacenIdRef = useRef(venta.almacen_Id);

    React.useEffect(() => {
        let titulo = ""
        switch (documentoS) {
            case 'cotizaciones':
                setTipoDocto('C');
                setDocto('Cotizacion');
                titulo = 'Cotizacion';
                break;
            case 'pedidos':
                setTipoDocto('P');
                setDocto('Pedido');
                titulo = 'Pedido';
                break;
            case 'remisiones':
                setTipoDocto('R');
                setDocto('Remision');
                titulo = 'Remision';
                break;
            default:
                setTipoDocto('C');
                setDocto('Cotizacion');
                titulo = 'Cotizacion';
                break;
        }
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: isAddMode ? "Registrar " + titulo : "Editar " + titulo,
            subtitulo: ''
        }));
    }, [documentoS, setGlobalTitulo, isAddMode]);

    React.useEffect(() => { if (ventaAlmacenIdRef) ventaAlmacenIdRef.current = venta.almacen_Id; }, [venta.almacen_Id]);

    if (getDataSession('sucursal') === '0') {
        Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
    }

    const aplicarCliente = useCallback((clienteAux) => {
        const primeraDireccion = clienteAux.clientes_Direcciones?.[0];
        setCliente(clienteAux);
        setDirecciones(primeraDireccion || {});
        setVenta(prev => ({
            ...prev,
            cliente_Id: clienteAux.id,
            direccion_Id: primeraDireccion?.id || 0
        }));
    }, []);

    const getCliente = useCallback(async (cliente_id) => {
        if (!cliente_id) {
            setCliente({});
            setDirecciones({});
            setVenta(prev => ({ ...prev, cliente_Id: 0, direccion_Id: 0 }));
            return;
        }
        const clienteAux = await fetchConToken(
            `Clientes?id=${cliente_id}&sucursal_Id=${getDataSession('sucursal')}`
        );
        clienteAux.regimen_Fiscal_Receptor =
            clienteAux.regimen_Fiscal_Receptor.replace(' ') === ''
                ? '601'
                : clienteAux.regimen_Fiscal_Receptor;
        clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
        clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
        clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
        aplicarCliente(clienteAux);
    }, [aplicarCliente])

    const facturar = () => {
        Swal.fire({
            title: isAddMode ? 'Crear ' + Docto : 'Editar ' + Docto,
            text: isAddMode
                ? `¿Desea crear esta ${Docto.toLowerCase()}?`
                : `¿Desea guardar los cambios en esta ${Docto.toLowerCase()}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: isAddMode ? 'Sí, crear' : 'Sí, guardar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) saveCliente();
        });
    };

    const cancelar = () => {
        Swal.fire({
            title: 'Cancelación',
            text: `¿Desea cancelar esta ${Docto.toLowerCase()}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cancelar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Ventas/Cancelar?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`,
                null, 'POST'
            ).then((response) => {
                setErroresV({});
                if (response.hasOwnProperty('status') && response.status === 400) {
                    Object.entries(response.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return false;
                }

                Swal.fire('Exito', Docto + ' Cancelada', 'success');
                venta.id > 0 ? history.push('..') : history.push('.');
                return true;
            });
        });
    }

    const terminar = () => {
        console.log("terminar");
        fetchConToken(
            `Ventas/Terminar?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`,
            null, 'POST'
        ).then((response) => {
            setErroresV({});
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            Swal.fire('Exito', Docto + ' Terminada', 'success');
            venta.id > 0 ? history.push('..') : history.push('.');
            return true;
        });
    }

    const saveCliente = () => {
        console.log("saveCliente");
        cliente.empresa_Id = getDataSession('empresa');
        cliente.sucursal_Id = getDataSession('sucursal');
        if (!cliente.hasOwnProperty('uso_Cfdi')) cliente.uso_Cfdi = 'G01';
        if (!cliente.hasOwnProperty('regimen_Fiscal_Receptor')) cliente.regimen_Fiscal_Receptor = '601';

        if (!cliente.hasOwnProperty('no_Cliente')) cliente.no_Cliente = 'local';

        cliente.sucursal_Id = getDataSession('sucursal');
        fetchConToken(
            `Clientes?sucursal_Id=${getDataSession('sucursal')}`,
            cliente,
            cliente.hasOwnProperty('id') && cliente.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresCliente('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            setCliente([]);
            setCliente(response);
            saveDireccion(response.id);
            return true;
        });
        return true;
        //.catch(alertService.error("91"));
    };

    const saveDireccion = (id) => {
        console.log("saveDireccion");
        console.log(id);
        direcciones.cliente_Id = id;
        if (!direcciones.hasOwnProperty('no_Direccion')) direcciones.no_Direccion = 'local';

        fetchConToken(
            `DireccionesClientes`,
            direcciones,
            direcciones.hasOwnProperty('id') && direcciones.id !== null ? 'PUT' : 'POST'
        ).then((response) => {
            setError(['']);
            setErroresV({});
            setErroresDirecciones('');
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                setError('Revisar errores');
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            setDirecciones([]);
            setDirecciones(response);
            guardarVenta(response.id);
            return true;
        });
        return true;
        //.catch(alertService.error("107"));
    };

    const getDireccion = useCallback(async (direccion_id) => {
        setVenta(resv => ({
            ...resv,
            direccion_Id: direccion_id
        }));
        const direccionAux = await fetchConToken(`DireccionesClientes?id=${direccion_id}`);
        setDirecciones(direccionAux);
        getCliente(direccionAux.cliente_Id);
    }, [getCliente])

    ////////Guardar Venta
    ///////////////////////////////////////////
    const guardarVenta = (id) => {
        console.log("guardarVenta");
        console.log('entro guardar venta');
        venta.sucursal_Id = getDataSession('sucursal');
        venta.direccion_Id = id;
        if (venta.direccion_Id === 0) {
            Swal.fire('Error', 'Seleccione una direccion', 'error');
            return false;
        }
        if (ventaDetalles.length === 0) {
            Swal.fire('Error', 'Seleccione por los menos un articulo', 'error');
            return false;
        }

        if (venta.forma_De_Pago.length === 0 || !venta.hasOwnProperty('forma_De_Pago'))
            venta.forma_De_Pago = '01';

        if (venta.metodo_Pago.length === 0 || !venta.hasOwnProperty('metodo_Pago'))
            venta.metodo_Pago = 'PUE';

        if (venta.length === 0 || !venta.hasOwnProperty('moneda')) venta.moneda = 'MXN';

        venta.venta_Detalles = ventaDetalles;
        venta.tipo_Documento = TipoDocto;
        fetchConToken(
            `Ventas?sucursal_Id=${getDataSession('sucursal')}
            &conceptos_cobros_id=${conceptos_cobros_id}
            &condicion_pago_id=${condicion_pago_id}`,
            venta,
            venta.hasOwnProperty('id') && venta.id > 0 ? 'PUT' : 'POST'
        ).then((response) => {
            setErroresV({});
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            //alertService.success('Venta guardada', { keepAfterRouteChange: true });
            Swal.fire('Exito', Docto + ' guardada', 'success');
            venta.id > 0 ? history.push('..') : history.push('.');

            setError('');
            setVenta(response);

            setVentaDetalles([]);
            setVentaDetalles(response.venta_Detalles);
            setFacturado(true);
            return true;
        });
        return true;
        //.catch(alertService.error("131"));
    };
    ///////////////////////////////////////////
    /*
        const saveArticulos = () => {
            setErroresArticulos({});
            setError('');
            ventaDetalles.map((art) => {
                art.articulo.descripcion =
                    art.articulo.descripcion.replace(' ') === ' ' ? '' : art.articulo.descripcion;
                fetchConToken(
                    `Articulos?sucursal_Id=${getDataSession('sucursal')}`,
                    art.articulo,
                    'PUT'
                ).then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach(([ , value]) => {
                            Swal.fire('Error', value[0] + ' Clave: ' + art.articulo.clave, 'error');
                        });
                        setError('Revisar errores');
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }
                });
                return true;
                //.catch(alertService.error("153"));
            });
    
            if (Object.entries(erroresArticulos).length > 0) return false;
            if (erroresArticulos[0] !== undefined) return false;
    
            return true;
        };*/

    React.useEffect(() => {
        async function getVenta() {
            const ventaAux = await fetchConToken(`Ventas?id=${id}&sucursal_Id=${getDataSession('sucursal')}`);
            ventaAux.forma_De_Pago = ventaAux.forma_De_Pago.replace(' ') === '' ? '01' : ventaAux.forma_De_Pago;
            ventaAux.metodo_Pago = ventaAux.metodo_Pago.replace(' ') === '' ? 'PUE' : ventaAux.metodo_Pago;
            setConceptos_cobros_id(ventaAux.conceptos_Cobros_Id);
            setCondicion_pago_id(ventaAux.condicion_Pago_Id);
            setVenta(ventaAux);
            getDireccion(ventaAux.direccion_Id);
            setVentaDetalles(ventaAux.venta_Detalles);
            return ventaAux.venta_Detalles.filter(e => e.requiere_Revision === true).length > 0;
        }
        async function getAlmacenes() {
            const response = await fetchConToken(`Almacenes/List?sucursal_Id=${sucursal_id}`);
            setAlmacenes(response);

            if (response?.length > 0) {
                if (!(ventaAlmacenIdRef.current > 0))
                    setVenta((venta) => ({
                        ...venta,
                        almacen_Id: response[0].id,
                    }));
            }
        }
        async function getSucursales() {
            console.log("getSucursales");
            const response = await fetchConToken(`Sucursales/GetList?empresa_id=${getDataSession('empresa')}&pagina=1&totalXpagina=50`);
            setSucursales(response);
        }
        async function getSatFormaPago() {
            console.log("getSatFormaPago");
            const response = await fetchConToken(`CatalogosSat/ListFormaPago?pagina=1&totalXpagina=300`);
            setSatFormaPago(response);
        }
        async function getSatPais() {
            console.log("getSatPais");
            const response = await fetchConToken(`CatalogosSat/ListPais?pagina=1&totalXpagina=300`);
            setSatPais(response);
        }
        async function getSeries(sucursal_id) {
            console.log("sucursal_id");
            const response = await fetchConToken(`Sucursales/GetFoliosSucursales?sucursal_Id=${sucursal_id}&tipo_Documento=F`);
            setSeries(response);
        }
        async function getConceptoPago() {
            const response = await fetchConToken(`VxConceptosCobros/List?sucursal_Id=${sucursal_id}`);
            setConceptoPago(response);
        }
        async function getcondicionesPago() {
            const response = await fetchConToken(`VxCondicionPagos/List?sucursal_Id=${sucursal_id}`);
            setCondicionPago(response);
        }
        getSucursales();
        getSatFormaPago();
        getSatPais();
        getSeries(getDataSession('sucursal'));
        getConceptoPago();
        getcondicionesPago();
        getAlmacenes();
        if (!isAddMode) getVenta();
    }, [id, isAddMode, sucursal_id, getDireccion]);

    const handleInputChangeCliente = ({ target }) => {
        console.log("handleInputChangeCliente");
        setCliente({
            ...cliente,
            [target.name]: target.value
        });

    };

    const handleInputChangeDireccion = ({ target }) => {
        console.log("handleInputChangeDireccion");
        setDirecciones({
            ...direcciones,
            [target.name]: target.value
        });
    };
    const handleInputChangeVenta = ({ target }) => {
        console.log("handleInputChangeVenta");
        setVenta({
            ...venta,
            [target.name]: target.value
        });
    };

    async function eliminar(id, variante_id) {
        if (isAddMode) {
            console.log("isAddMode")
            //console.log(id)
            //console.log(variante_id)
            //console.log(ventaDetalles.filter((item) => item.articulo_Id !== id || item.articulo_Variante_Id !== variante_id ));
            setVentaDetalles(ventaDetalles.filter((item) => item.articulo_Id !== id || item.articulo_Variante_Id !== variante_id));
        }
        else {
            var det = ventaDetalles.filter((d) => d.articulo_Id === id && d.articulo_Variante_Id === variante_id);
            console.log(det)
            det.forEach(detV => {
                console.log(detV)
                if (detV?.id > 0) {
                    console.log("entro cantidad 0");
                    detV.cantidad = 0;
                    detV.precio_Total = 0;
                    detV.impuesto_Total = 0;
                    setVentaDetalles(ventaDetalles.map((d) => (d.articulo_Id === id && d.articulo_Variante_Id === variante_id ? detV : d)));
                }
                else {
                    console.log("entro eliminar");
                    setVentaDetalles(ventaDetalles.filter((item) => item.articulo_Id !== id && item.articulo_Variante_Id !== variante_id));
                }
            })
        }
        console.log(ventaDetalles)
    }

    ////Clientes
    /////////////////////////////////////////////
    async function getClientes(page) {
        console.log("getClientes");
        setModalValor('cliente');
        const response = await fetchConToken(
            `Clientes/GetList?paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${busqueda.value}&sucursal_Id=${getDataSession('sucursal')}`
        );
        setClientes(response.data);
        //getDirecciones();
    }

    // async function getCliente(cliente_id) {
    //     console.log("getCliente");
    //     const clienteAux = await fetchConToken(
    //         `Clientes?id=${cliente_id}&sucursal_Id=${getDataSession('sucursal')}`
    //     );
    //     clienteAux.regimen_Fiscal_Receptor =
    //         clienteAux.regimen_Fiscal_Receptor.replace(' ') === ''
    //             ? '601'
    //             : clienteAux.regimen_Fiscal_Receptor;
    //     clienteAux.uso_Cfdi = clienteAux.uso_Cfdi.replace(' ') === '' ? 'G01' : clienteAux.uso_Cfdi;
    //     clienteAux.estatus = clienteAux.estatus.replace(' ') === '' ? 'A' : clienteAux.estatus;
    //     clienteAux.rfc = clienteAux.estatus.replace(' ') === '' ? '' : clienteAux.rfc;
    //     setCliente(clienteAux);
    //     setDirecciones(clienteAux.clientes_Direcciones[0]);
    //     venta.direccion_Id = clienteAux.clientes_Direcciones[0].id;
    //     venta.cliente_Id = cliente_id;
    // }
    ////////////////////////////////////////////

    /////////Direcciones
    ///////////////////////////////////////////
    async function getDirecciones(page) {
        console.log("getDirecciones");
        console.log(cliente);
        if (cliente.length === 0) {
            setError('Seleccione un cliente');
            return;
        }
        setModalValor('direccion');
        const direccionAux = await fetchConToken(
            `DireccionesClientes/GetList?paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${cliente.id}`
        );

        console.log(direccionAux);
        setDireccionesList(direccionAux);
        getCliente(direccionAux.cliente_Id);
        openModal();
    }

    ///////////Articulos
    ///////////////////////////////////////////
    async function getArticulos(page) {
        setModalValor('articulo');
        const articulosAux = await fetchConToken(`Articulos/GetList?paginas=${page}&totalXpagina=${totalxPagina}&busqueda=${busqueda.value}&sucursal_Id=${getDataSession('sucursal')}`);
        setArticulos(articulosAux?.data);
    }

    async function getArticulo(art) {
        if (!Number.isInteger(art?.id)) return;
        let artAux
        if (art.variante === 'N') {
            artAux = ventaDetalles.filter((d) => d.articulo_Id === art.id);
            if (artAux.length > 0) {
                artAux[0].cantidad = artAux[0].cantidad + 1;
                setVentaDetalles(ventaDetalles.map((det) => (det.articulo_Id === art.id ? artAux[0] : det)));
                ImpuestosArticulo(ventaDetalles.filter(x => x.articulo_Id === art.id), false, artAux[0].articulo);
                return;
            }

            const articulosAux = await fetchConToken(`Articulos?id=${art.id}&sucursal_Id=${getDataSession('sucursal')}&cliente_id=${venta.cliente_Id}`);
            const detalleVenta = {
                id: 0,
                venta_Id: 0,
                articulo_Variante_Id: 0,
                articulo_Id: articulosAux.id,
                no_Detalle: 'local',
                posicion: 0,
                cantidad: 1,
                clave_Unidad: articulosAux.clave_Unidad,
                precio_Unitario: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.precio_Sin_Impuesto),
                descuento_Total: 0,
                precio_Total: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.costo_Unidad),
                impuesto_Total: 0,
                estatus: 'A',
                articulo: articulosAux,
                nombre_Articulo: articulosAux.nombre,
                impuesto: 0,
                precioSinImpuesto: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.precio_Sin_Impuesto),
                clave_Articulo: articulosAux.clave
            };
            ImpuestosArticulo(detalleVenta, true, articulosAux);
        }
        else {
            artAux = ventaDetalles.filter((d) => d.articulo_Variante_Id === art.id);
            if (artAux.length > 0) {
                artAux[0].cantidad = artAux[0].cantidad + 1;
                setVentaDetalles(ventaDetalles.map((det) => (det.articulo_Variante_Id === art.id ? artAux[0] : det)));
                ImpuestosArticulo(ventaDetalles.filter(x => x.articulo_Variante_Id === art.id), false, artAux[0].articulo);
                return;
            }

            const articulosVariante = await fetchConToken(`Articulos/VarianteById?variante_id=${art.id}`);
            const articulosAux = await fetchConToken(`Articulos?id=${articulosVariante.articulo_Id}&sucursal_Id=${getDataSession('sucursal')}&cliente_id=${venta.cliente_Id}`);
            const detalleVenta = {
                id: 0,
                venta_Id: 0,
                articulo_Variante_Id: art.id,
                articulo_Id: articulosVariante.articulo_Id,
                no_Detalle: 'local',
                posicion: 0,
                cantidad: 1,
                clave_Unidad: articulosAux.clave_Unidad,
                precio_Unitario: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.precio_Sin_Impuesto),
                descuento_Total: 0,
                precio_Total: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.costo_Unidad),
                impuesto_Total: 0,
                estatus: 'A',
                articulo: articulosAux,
                nombre_Articulo: art.nombre,
                impuesto: 0,
                precioSinImpuesto: (articulosAux.cliente_Precio != null ? articulosAux.cliente_Precio.precio : articulosAux.precio_Sin_Impuesto),
                clave_Articulo: art.clave
            };
            ImpuestosArticulo(detalleVenta, true, articulosAux);
        }
    }

    ///////////////////////////////////////////

    function ImpuestosArticulo(ventaDet, nuevaLinea, articulo) {
        if (nuevaLinea) {
            fetchConToken(`ventas/CalculaDetalle?sucursal_Id=` + getDataSession('sucursal'), ventaDet, 'POST').then((detVentaResp) => {
                detVentaResp.articulo = detVentaResp.articulo ? detVentaResp.articulo : articulo;
                setVentaDetalles([...ventaDetalles, detVentaResp]);
            });
        }
        else {
            fetchConToken(`ventas/CalculaDetalle?sucursal_Id=` + getDataSession('sucursal'), ventaDet[0], 'POST')
                .then((detVentaResp) => {
                    detVentaResp.articulo = detVentaResp.articulo ? detVentaResp.articulo : articulo;
                    var detAux = ventaDetalles.map((det) => (det.articulo_Id === detVentaResp.articulo_Id && det.articulo_Variante_Id === detVentaResp.articulo_Variante_Id) ? detVentaResp : det);
                    setVentaDetalles(detAux);
                });
        }
    }

    /////////// Detalles venta
    //////////////////////////////////////////
    const handleInputChangeDetallesVenta = (event, key, variante_id, campo) => {
        let detalleV = ventaDetalles.filter((det) => det.articulo_Id === key && det.articulo_Variante_Id === variante_id);
        switch (campo) {
            case "cantidad":
                detalleV[0][campo] = parseFloat(event.target.value);
                break;
            case "precio_Unitario":
                detalleV[0]["precio_Unitario"] = parseFloat(event.target.value);
                break;
            default:
                detalleV[0][campo] = event.target.value;
                break;
        }
        if (campo !== "nombre_Articulo")
            ImpuestosArticulo(ventaDetalles.filter(x => x.articulo_Id === key && x.articulo_Variante_Id === variante_id), false, detalleV[0].articulo);
    };
    //////////

    const loadClientes = async (query) => {
        console.log("loadClientes");
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }
        var resp = await fetchConToken(`Clientes/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
        return resp.data;
    };

    const loadArticulos = async (query) => {
        console.log("loadArticulos");
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }

        //console.log(venta);
        var resp = await fetchConToken(`Articulos/ListArtYVar?busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
        /*var resp = await fetchConToken(
            `Articulos/GetList?paginas=0&totalXpagina=50&busqueda=${query}&cliente_id=${venta?.cliente_Id}&sucursal_Id=${getDataSession(
                'sucursal'
            )}`
        );*/
        return resp;
    };

    /*const loadDireccion = async (query) => {
        var resp = await fetchConToken(
            `DireccionesClientes/GetList?paginas=1&totalXpagina=50&busqueda=${cliente.id}`
        );
        return resp; 
    };*/

    async function descripcionDetalle(id) {
        //setVentaDetalles([]);
        console.log("descripcionDetalle");
        var detAux = ventaDetalles.filter((d) => d.articulo_Id === id);
        Swal.fire({
            title: 'Agregar descripción al detalle',
            input: 'textarea',
            inputValue: detAux[0]?.descripcion,
            inputAttributes: { autocapitalize: 'off' },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Guardar',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                detAux[0].descripcion = result.value;
                //console.log(detAux)
                setVentaDetalles(ventaDetalles.map((det) => (det.articulo_Id === id ? detAux[0] : det)));
            }
        })
        //console.log(ventaDetalles)
    }

    const convertir = () => {
        const destino = TipoDocto === 'C' ? 'pedido' : 'remisión';
        Swal.fire({
            title: 'Convertir documento',
            text: `¿Desea convertir esta ${Docto.toLowerCase()} a ${destino}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, convertir',
            cancelButtonText: 'No'
        }).then((result) => {
            if (!result.isConfirmed) return;

            var url = "";
            if (TipoDocto === 'C') url = `Cotizaciones/ConvertirAPedido?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`;
            if (TipoDocto === 'P') url = `Pedidos/ConvertirARemision?documento_id=${id}&sucursal_id=${getDataSession('sucursal')}`;

            fetchConToken(url, null, 'post').then(async (resp) => {
                try {
                    if (resp.hasOwnProperty('status') && resp.status === 400) {
                        Object.entries(resp.errors).forEach(([, value]) => {
                            Swal.fire('Error', value[0], 'error');
                        });
                        return false;
                    } else if (resp.hasOwnProperty('codigo') && resp.codigo !== 200) {
                        Swal.fire('Error', resp.mensajes[0], 'error');
                        return false;
                    }
                    Swal.fire('Exito', 'El documento se convirtio correctamente', 'success');
                } catch (error) {
                    console.error('Error al convertir el documento:', error);
                }
            });
        });
    }

    return (<>
        <div className='container-fluid'>
            <form onSubmit={handleSubmit(facturar)} className='facturar' /*onReset=""*/>
                <div className='col-md-12 text-right'>
                    {venta.id > 0 && (TipoDocto === 'C' ) && (venta.estatus !== 'T' && venta.estatus !== 'C') ? <>
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => convertir()}
                            type='button'
                        >
                            &nbsp; Convertir a {TipoDocto === 'C' ? "Pedido" : "Remision"}
                        </button>
                        &nbsp;
                    </> : ""}
                    {(venta.id > 0 && venta.folio_venta === null && venta.estatus !== 'C' && venta.estatus !== 'T') ? <>
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => terminar()}
                            type='button'
                        >
                            &nbsp; Terminar {Docto}
                        </button>
                        &nbsp;
                    </> : ""}
                    <button
                        hidden={facturado || venta.estatus === 'C' || venta.estatus === 'T'}
                        className='btn btn-outline-success'
                        //onClick={ (e) => facturar() }
                        type='submit'
                    >
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-check-lg'
                            viewBox='0 0 16 16'
                        >
                            <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                        </svg>
                        &nbsp; Guardar
                    </button>
                    &nbsp;
                    <button
                        hidden={facturado || venta.estatus === 'C' || venta.id === 0}
                        className='btn btn-outline-success'
                        onClick={(e) => cancelar()}
                        type='button'
                    >
                        &nbsp; Cancelar {Docto}
                    </button>
                    &nbsp;
                    <Link to={isAddMode ? '.' : '..'} className='btn btn-outline-warning'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='15'
                            height='15'
                            fill='currentColor'
                            className='bi bi-reply'
                            viewBox='0 0 16 16'
                        >
                            <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                        </svg>
                        &nbsp; Regresar
                    </Link>
                </div>
                <p style={{ color: 'red' }}>{error}</p>
                <div className='row'>
                    <div className='row col-md-12'>
                        <h5>Información del cliente</h5>
                        {Object.entries(erroresCliente).map(([, value]) => { return (<><p style={{ color: 'red' }}>{value}</p></>); })}
                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-2 '>
                                <div className='card-body text-start'>
                                    <input
                                        type='hidden'
                                        className='form-control'
                                        name='no_cliente'
                                        value={cliente.no_Cliente}
                                        onChange={handleInputChangeCliente}
                                        disabled={false/*facturado*/}
                                        required
                                    />
                                    <label htmlFor='id'>Cliente:</label>
                                    <AsyncSelect
                                        className='react-select-placeholder'
                                        isClearable
                                        getOptionLabel={(option) =>
                                            option.rfc + '-' + option.nombre
                                        }
                                        getOptionValue={(option) => option.id}
                                        //defaultValue={initialObject.clave}
                                        loadOptions={loadClientes}
                                        onChange={(selectedItem) => {
                                            if (selectedItem === null) {
                                                getCliente('');
                                                return;
                                            }
                                            aplicarCliente(selectedItem);
                                        }}
                                    />
                                    <label htmlFor='nombre'>Nombre*</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='nombre'
                                        value={cliente.nombre}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                        required
                                    />
                                    <label htmlFor='rfc'>RFC*</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='rfc'
                                        value={cliente?.rfc || ''}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                        required
                                    />
                                    <label htmlFor='cp'>Codigo Postal*</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='cp'
                                        value={direcciones?.cp || ''}
                                        onChange={handleInputChangeDireccion}
                                        disabled={facturado}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-2 '>
                                <div className='card-body text-start'>
                                    <label htmlFor='correo'>Correo*</label>
                                    <input
                                        type='email'
                                        className='form-control'
                                        name='correo'
                                        value={cliente?.correo || ''}
                                        onChange={handleInputChangeCliente}
                                        disabled={facturado}
                                        required
                                    />
                                    <label htmlFor='correo'>Descripción </label>
                                    <textarea rows="4"
                                        className='form-control'
                                        name='descripcion'
                                        value={venta?.descripcion || ''}
                                        onChange={handleInputChangeVenta}
                                        disabled={facturado}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4' style={{ display: 'grid' }}>
                            <div className='card mb-2 '>
                                <div className='card-body text-start'>
                                    <div className='col-md-12'></div>
                                    <label htmlFor='forma_De_Pago'>Almacen</label>
                                    <select
                                        className='form-control'
                                        name='almacen_Id'
                                        value={venta.almacen_Id}
                                        onChange={handleInputChangeVenta}
                                        required
                                    >
                                        {almacenes?.map(alm => {
                                            return (
                                                venta.almacen_Id === alm.id ?
                                                    <option value={alm.id} selected>{alm.nombre}</option> :
                                                    <option value={alm.id}>{alm.nombre}</option>
                                            );
                                        })}
                                    </select>
                                    <label htmlFor='forma_De_Pago'>Forma de Pago</label>
                                    <select
                                        className='form-control'
                                        name='forma_De_Pago'
                                        value={venta.forma_De_Pago}
                                        onChange={handleInputChangeVenta}
                                        disabled={facturado}
                                        required
                                    >
                                        {satFormaPago.map((formapago) => {
                                            return (
                                                <option key={formapago.id} value={formapago.clave}>
                                                    {formapago.clave + ' - ' + formapago.nombre}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <label htmlFor='metodo_Pago'>Metodo de Pago</label>
                                    <select
                                        className='form-control'
                                        name='metodo_Pago'
                                        value={venta.metodo_Pago}
                                        onChange={handleInputChangeVenta}
                                        disabled={facturado}
                                        required
                                    >
                                        <option value='PUE'>
                                            (PUE) Pago en una sola exhibición
                                        </option>
                                        <option value='PPD'>
                                            (PPD) Pago en Parcialidades o Diferido
                                        </option>
                                    </select>
                                    {(TipoDocto === 'R') ? <>
                                        <label htmlFor='conceptos_cobros_id'>Concepto de pago</label>
                                        <select
                                            className='form-control'
                                            name='metodo_Pago'
                                            value={conceptos_cobros_id}
                                            onChange={({ target }) => { setConceptos_cobros_id(target.value) }}
                                            required
                                        >
                                            {conceptoPago?.map(c => {
                                                return (conceptos_cobros_id === c.id ? <option value={c.id} selected>{c.nombre}</option> : <option value={c.id}>{c.nombre}</option>);
                                            })}
                                        </select>

                                        <label htmlFor='condicion_pago_id'>Condicion de pago</label>
                                        <select
                                            className='form-control'
                                            name='metodo_Pago'
                                            value={condicion_pago_id}
                                            onChange={({ target }) => { setCondicion_pago_id(target.value) }}
                                            required
                                        >
                                            {condicionPago.map(c => {
                                                return (condicion_pago_id === c.id ? <option value={c.id} selected>{c.nombre}</option> : <option value={c.id}>{c.nombre}</option>);
                                            })}
                                        </select>
                                    </> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    {Object.entries(erroresDirecciones).map(([, value]) => { return (<><p style={{ color: 'red' }}>{value}</p></>); })}
                    {/*<div
                            className='col-md-12 text-left'
                            style={{ marginTop: '-10px', marginBottom: '5px' }}
                        >
                            <label htmlFor='id'>
                        
                                    Buscar direccion
                             
                            </label>
                            <AsyncSelect
                                        isClearable
                                        getOptionLabel={(option) =>
                                            option.clave + '-' + option.nombre + "- $" + option.costo_Unidad
                                        }
                                        getOptionValue={(option) => option.id}
                                        //defaultValue={initialObject.clave}
                                        loadOptions={loadDireccion}
                                        onChange={(selectedItem) => {
                                            const val =
                                                selectedItem === null ? '' : selectedItem?.id;
                                                getArticulo(val);
                                        }}
                                        />
                        </div>*/}
                    <div className='accordion' id='accordionExample'>
                        <div className='accordion-item'>
                            <h2 className='accordion-header' id='headingOne'>
                                <button
                                    className='accordion-button collapsed'
                                    type='button'
                                    data-bs-toggle='collapse'
                                    data-bs-target='#collapseOne'
                                    aria-expanded='true'
                                    aria-controls='collapseOne'
                                    style={{ color: '#0c63e4', backgroundColor: '#e7f1ff' }}
                                >
                                    <h6>Datos Opcionales</h6>
                                </button>
                            </h2>
                            <div
                                id='collapseOne'
                                className='accordion-collapse collapse'
                                aria-labelledby='headingOne'
                                data-bs-parent='#accordionExample'
                            >
                                <div className='accordion-body row'>
                                    <div className='col-md-4' style={{ display: 'grid' }}>
                                        <div className='card'>
                                            <div className='card-body text-start'>
                                                <label htmlFor='calle'>Calle</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='calle'
                                                    value={direcciones?.calle || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='no_Exterior'>No Exterior</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='no_Exterior'
                                                    value={direcciones?.no_Exterior || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='no_Interior'>No Interior</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='no_Interior'
                                                    value={direcciones?.no_Interior || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4' style={{ display: 'grid' }}>
                                        <div className='card'>
                                            <div className='card-body text-start'>
                                                <label htmlFor='colonia'>Colonia</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='colonia'
                                                    value={direcciones?.colonia || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='poblacion'>Poblacion</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='poblacion'
                                                    value={direcciones?.poblacion || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='ciudad'>Ciudad</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='ciudad'
                                                    value={direcciones?.ciudad || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4' style={{ display: 'grid' }}>
                                        <div className='card'>
                                            <div className='card-body text-start'>
                                                <label htmlFor='estado'>Municipio</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='municipio'
                                                    value={direcciones?.municipio || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='estado'>Estado</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    name='estado'
                                                    value={direcciones?.estado || ''}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                />
                                                <label htmlFor='pais'>Pais:</label>
                                                <select
                                                    className='form-control'
                                                    name='pais'
                                                    value={direcciones?.pais || 'México'}
                                                    onChange={handleInputChangeDireccion}
                                                    disabled={facturado}
                                                    required
                                                >
                                                    {satPais.map((pais) => { return (<option key={pais.id} value={pais.nombre}>{pais.clave + ' - ' + pais.nombre}</option>); })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='card-title'>
                            <div className='col-md-12'>
                                {Object.entries(erroresV).map(([key, value]) => { return (<><p style={{ color: 'red' }}>{value}</p></>); })}
                            </div>
                        </div>
                    </div>
                    <div
                        className='col-md-12 row'
                        style={{ paddingTop: '7px', paddingBottom: '7px' }}
                    >
                        {/* <div className='col-4 col-sm-4 col-md-4 '>
                            <label >Sucursal</label>
                            <select className='form-select' name='sucursal_Id' onChange={handleInputChangeSucursal} disabled={facturado}>
                                {sucursales.map(sucursal=>{
                                    return (
                                      (sucursal_id === sucursal.id) ?  (<option value={sucursal.id} selected>{sucursal.nombre}</option>) : (<option value={sucursal.id}>{sucursal.nombre}</option>)
                                    );
                                })}
                            </select>
                            </div>
                            <div className='col-4 col-sm-4 col-md-4 '>
                            <label>Serie</label>
                            <select className='form-select' onChange={handleInputChangeSerie} disabled={facturado}>
                                {series.map(s=>{
                                    return (
                                       s === s.id ? <option value={s.id} selected>{s.serie}</option> : <option value={s.id}>{s.serie}</option>
                                    );
                                })}
                            </select>
                            </div>
                            */}
                        <div className='col-12 col-sm-12 col-md-12 text-left'>
                            <label htmlFor='id'>Buscar Articulo</label>
                            <AsyncSelect
                                className='react-select-placeholder'
                                isClearable
                                getOptionLabel={(option) =>
                                    option.clave +
                                    '-' +
                                    option.nombre
                                }
                                value=''
                                getOptionValue={(option) => option.id}
                                //defaultValue={initialObject.clave}
                                loadOptions={loadArticulos}
                                onChange={(selectedItem) => {
                                    getArticulo(selectedItem);
                                }}
                            />
                        </div>
                    </div>
                    <div className='col-md-12' style={{ display: 'grid' }}>
                        <div className='card mb-3 '>
                            <div className='text-start'>
                                <div className='card col-12 col-sm-12 col-md-12'>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th style={{ display: "none" }}>ID</th>
                                                    <th>Articulo</th>
                                                    <th>Clave</th>
                                                    <th>Cantidad</th>
                                                    <th>Precio Unitario <br></br> (sin impuestos)</th>
                                                    <th>IVA</th>
                                                    <th>Precio Total</th>
                                                    <th style={{ width: "50px" }} hidden={facturado}></th>
                                                    <th style={{ width: "50px" }} hidden={facturado}></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ventaDetalles?.filter(i => i.cantidad > 0)?.map((item) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td className='text-center' style={{ display: "none" }}>
                                                                {item.articulo_Id}
                                                            </td>
                                                            <td>
                                                                <textarea
                                                                    disabled={facturado}
                                                                    type='text'
                                                                    className='form-control'
                                                                    name='item.nombre_Articulo'
                                                                    value={
                                                                        item.nombre_Articulo
                                                                    }
                                                                    onChange={(event) =>
                                                                        handleInputChangeDetallesVenta(
                                                                            event,
                                                                            item.articulo_Id,
                                                                            item.articulo_Variante_Id,
                                                                            'nombre_Articulo'
                                                                        )
                                                                    }
                                                                    cols="170"
                                                                    rows="3"
                                                                />
                                                            </td>
                                                            <td className='text-center'>
                                                                {item.clave_Articulo}
                                                            </td>
                                                            <td className='text-right'>
                                                                <input
                                                                    type='number'
                                                                    className='form-control'
                                                                    name='item.cantidad'
                                                                    value={item.cantidad}
                                                                    onChange={(event) =>
                                                                        handleInputChangeDetallesVenta(
                                                                            event,
                                                                            item.articulo_Id,
                                                                            item.articulo_Variante_Id,
                                                                            'cantidad'
                                                                        )
                                                                    }
                                                                    disabled={facturado}
                                                                />
                                                            </td>
                                                            <td className='text-right'>
                                                                <input
                                                                    type='number'
                                                                    className='form-control'
                                                                    name='item.precio_Unitario'
                                                                    value={item.precio_Unitario}
                                                                    onChange={(event) =>
                                                                        handleInputChangeDetallesVenta(
                                                                            event,
                                                                            item.articulo_Id,
                                                                            item.articulo_Variante_Id,
                                                                            'precio_Unitario'
                                                                        )
                                                                    }
                                                                    disabled={facturado}
                                                                />
                                                            </td>
                                                            <td className='text-right'>
                                                                {currency(item.impuesto_Total)}
                                                            </td>
                                                            <td className='text-right'>
                                                                {currency(item.precio_Total + item.impuesto_Total)}
                                                            </td>
                                                            <td style={{ width: "50px" }} hidden={facturado}>
                                                                <button
                                                                    type='button'
                                                                    className='btn  mr-1'
                                                                    onClick={() =>
                                                                        eliminar(
                                                                            item.articulo_Id,
                                                                            item.articulo_Variante_Id
                                                                        )
                                                                    }
                                                                >
                                                                    <svg
                                                                        xmlns='http://www.w3.org/2000/svg'
                                                                        width='25'
                                                                        height='25'
                                                                        fill='currentColor'
                                                                        className='bi bi-x-circle-fill'
                                                                        viewBox='0 0 16 16'
                                                                    >
                                                                        <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
                                                                    </svg>
                                                                </button>
                                                            </td>
                                                            <td style={{ width: "50px" }}>
                                                                <button
                                                                    type='button'
                                                                    className='btn  mr-1'
                                                                    onClick={() =>
                                                                        descripcionDetalle(
                                                                            item.articulo_Id
                                                                        )
                                                                    }
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-chat-left-text" viewBox="0 0 16 16">
                                                                        <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                                        <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                                                                    </svg>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr>
                                                    <td colSpan={6} className='text-right'>
                                                        Subtotal:
                                                        {currency(
                                                            ventaDetalles.reduce(
                                                                (a, v) => (a = a + v.precio_Total),
                                                                0
                                                            )
                                                        )}
                                                    </td>
                                                    <td colSpan={2} className='text-right'>
                                                        IVA:{' '}
                                                        {currency(
                                                            ventaDetalles.reduce(
                                                                (a, v) => (a = a + v.impuesto_Total),
                                                                0
                                                            )
                                                        )}
                                                    </td>

                                                    <td colSpan={2} className='text-right'>
                                                        Total:{' '}
                                                        {currency(
                                                            ventaDetalles.reduce(
                                                                (a, v) =>
                                                                    (a = a + v.precio_Total + v.impuesto_Total),
                                                                0
                                                            )
                                                        )}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <Modal isOpen={isOpenModal} closeModal={closeModal}>
            {modalValor === 'cliente' ? (
                <>
                    {' '}
                    <br />
                    <div className='row'>
                        <div className='col-md-2 tex-left'>
                            <label>Buscar</label>
                        </div>
                        <div className='col-md-8 '>
                            <input type='text' className='form-control' {...busqueda} />
                        </div>
                        <div className='col-md-2 text-left'>
                            <button
                                type='button'
                                className='btn btn-outline-secondary'
                                onClick={() => getClientes(1)}
                                style={{ border: 'none' }}
                            >
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='16'
                                    height='16'
                                    fill='currentColor'
                                    className='bi bi-search'
                                    viewBox='0 0 16 16'
                                >
                                    <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <br></br>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th width='40px'>#No</th>
                                <th>Clave</th>
                                <th>Nombre</th>
                                <th className='text-center'>RFC</th>
                                <th width='160px'>Estatus</th>
                                <th className='text-center'>Editar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.no_cliente}</td>
                                        <td>{item.nombre}</td>
                                        <td>{item.rfc}</td>
                                        <td>{item.estatus === 'A' ? 'Activo' : 'Inactivo'}</td>
                                        <td className='text-center'>
                                            <button
                                                className='btn btn-outline-warning'
                                                type='button'
                                                onClick={function (event) {
                                                    getCliente(item.id);
                                                    closeModal();
                                                }}
                                            >
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    width='25'
                                                    height='25'
                                                    fill='currentColor'
                                                    className='bi bi-check2'
                                                    viewBox='0 0 16 16'
                                                >
                                                    <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <Pagination
                        consumirPaginacion={getClientes}
                        elementos={clientes.length}
                        totalxPagina={totalxPagina}
                    />
                </>
            ) : (
                ''
            )}
            {modalValor === 'direccion' ? (
                <>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th width='40px'>#No</th>
                                <th>Codigo Postal</th>
                                <th>Calle</th>
                                <th className='text-center'>No. Exterior</th>
                                <th width='160px'>No. Interior</th>
                                <th className='text-center'>Colonia</th>
                                <th className='text-center'>Poblacion</th>
                                <th className='text-center'>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {direccionesList.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.cp}</td>
                                        <td>{item.calle}</td>
                                        <td>{item.no_Exterior}</td>
                                        <td>{item.no_Interior}</td>
                                        <td>{item.colonia}</td>
                                        <td>{item.poblacion}</td>
                                        <td>{item.estado}</td>
                                        <td className='text-center'>
                                            <button
                                                className='btn btn-outline-warning'
                                                type='button'
                                                onClick={function (event) {
                                                    getDireccion(item.id);
                                                    closeModal();
                                                }}
                                            >
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    width='25'
                                                    height='25'
                                                    fill='currentColor'
                                                    className='bi bi-check2'
                                                    viewBox='0 0 16 16'
                                                >
                                                    <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <Pagination
                        consumirPaginacion={getDirecciones}
                        elementos={direcciones.length}
                        totalxPagina={totalxPagina}
                    />
                </>
            ) : (
                ''
            )}

            {modalValor === 'articulo' ? (
                <>
                    {' '}
                    <br />
                    <div className='row'>
                        <div className='col-md-2 tex-left'>
                            <label>Buscar</label>
                        </div>
                        <div className='col-md-8 '>
                            <input type='text' className='form-control' {...busqueda} />
                        </div>
                        <div className='col-md-2 text-left'>
                            <button
                                type='button'
                                className='btn btn-outline-secondary'
                                onClick={() => getArticulos(1)}
                                style={{ border: 'none' }}
                            >
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='16'
                                    height='16'
                                    fill='currentColor'
                                    className='bi bi-search'
                                    viewBox='0 0 16 16'
                                >
                                    <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <br></br>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th width='40px'>#No</th>
                                <th>Clave</th>
                                <th>Nombre</th>
                                <th className='text-center'>No Identificacion</th>
                                <th width='160px'>Clave Prod.Ser.</th>
                                <th className='text-center'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {articulos.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.clave}</td>
                                        <td>{item.nombre}</td>
                                        <td>{item.no_Identificacion}</td>
                                        <td>{item.clave_Prod_Serv}</td>
                                        <td className='text-center'>
                                            <button
                                                className='btn btn-outline-warning'
                                                type='button'
                                                onClick={function (event) {
                                                    getArticulo(item.id);
                                                    closeModal();
                                                }}
                                            >
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    width='25'
                                                    height='25'
                                                    fill='currentColor'
                                                    className='bi bi-check2'
                                                    viewBox='0 0 16 16'
                                                >
                                                    <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <Pagination
                        consumirPaginacion={getArticulos}
                        elementos={articulos.length}
                        totalxPagina={totalxPagina}
                    />
                </>
            ) : (
                ''
            )}
        </Modal>
    </>);
};

const useFormInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
    return {
        value,
        onChange: handleChange
    };
};
export { AddEdit };
